module.exports = __webpack_public_path__ + "is.svg?2c3b9decb9e6eeff88565452a4be54f6";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/is.svg
// module id = 1427
// module chunks = 0